export default __webpack_public_path__ + "6cab621f17eb3779414bd82b0d234ffe.jpg";